/**
 * @generated SignedSource<<7b180c962bc72e8b332343ebebb9a024>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgWorkspaceAdminDeleteMutation$variables = {
  workspaceId: string;
};
export type OrgWorkspaceAdminDeleteMutation$data = {
  readonly workspace: {
    readonly delete: {
      readonly id: string;
    } | null;
  };
};
export type OrgWorkspaceAdminDeleteMutation = {
  response: OrgWorkspaceAdminDeleteMutation$data;
  variables: OrgWorkspaceAdminDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "delete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgWorkspaceAdminDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgWorkspaceAdminDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4385f69efc393c2150bf1168fdb40a94",
    "id": null,
    "metadata": {},
    "name": "OrgWorkspaceAdminDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrgWorkspaceAdminDeleteMutation(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    delete {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "70bddc0b21133fde55ded50cd1e7ebab";

export default node;
